import { render, staticRenderFns } from "./EGradeDiasHorarios.vue?vue&type=template&id=31c53e0c&scoped=true"
import script from "./EGradeDiasHorarios.vue?vue&type=script&lang=js"
export * from "./EGradeDiasHorarios.vue?vue&type=script&lang=js"
import style0 from "./EGradeDiasHorarios.vue?vue&type=style&index=0&id=31c53e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c53e0c",
  null
  
)

export default component.exports